import React from 'react'
import { TooltipList } from './TooltipList'
import { Flex, Tag } from '@chakra-ui/core'
import { ITag } from 'constants/interfaces'

interface TagsPrevewProps {
  tags: ITag[]
  visibleCount: number
}
export default function TagsPrevew({ tags, visibleCount }: TagsPrevewProps) {
  const visibleTags = tags.slice(0, visibleCount)
  const hiddenTagsCount = tags.length - visibleTags.length
  return (
    <TooltipList items={tags.map((item) => item.name)}>
      <Flex alignItems="center" style={{ columnGap: '5px' }}>
        {visibleTags.map((tag) => {
          const tagColor = tag.tag_color
          return (
            <Tag
              alignItems="center"
              justifyContent="center"
              key={tag.sk}
              fontSize="10px"
              bg={`${tagColor}25`}
              color={tagColor}
              w="max-content"
              maxWidth="120px"
              border="1px solid"
              px="5px"
              minHeight="unset"
              borderRadius="full"
              isTruncated
            >
              {tag.name}
            </Tag>
          )
        })}
        {hiddenTagsCount > 0 && (
          <Tag
            fontSize="10px"
            bg="gray.100"
            alignItems="center"
            justifyContent="center"
            color="gray.600"
            w="max-content"
            minWidth="unset"
            border="1px solid"
            px="2px"
            minHeight="unset"
            borderRadius="full"
          >
            +{hiddenTagsCount}
          </Tag>
        )}
      </Flex>
    </TooltipList>
  )
}
